import { Injectable, inject } from '@angular/core';
import { RichEditSpellcheckerCallback } from '../typing/rich-edit-spell-checker-callback';
import { SpellcheckMap } from '../typing/spellcheck-map';
import { SpellCheckCommand } from '../helpers/enums/spellcheck-command';
import { SpellcheckWorkerAdapterService } from './spellcheck-worker-adapter.service';
import { SpellCheckMessage } from '../interfaces/spellcheck-message';
import { Observable, Subscription } from 'rxjs';

@Injectable()
export class SpellcheckerService {
  private readonly worker = inject(SpellcheckWorkerAdapterService);

  private responseCallbacks: SpellcheckMap = new Map();
  private requestId = 0;
  private subscription?: Subscription;

  init(): Observable<void> {
    if (!this.subscription) {
      this.worker.build();
      this.subscription = this.worker.message$.subscribe(
        this.messageHandler.bind(this)
      );
    }

    return this.worker.ready$.asObservable();
  }

  checkWordSpelling(
    word: string,
    callback: RichEditSpellcheckerCallback
  ): void {
    if (this.worker.hasWorker()) {
      const id = this.requestId++;
      this.responseCallbacks.set(id, callback);
      this.worker.post({
        command: SpellCheckCommand.CheckWord,
        word,
        id,
      });
    }
  }

  addWordToDictionary(word: string): void {
    this.worker.post({
      command: SpellCheckCommand.AddWord,
      word,
    });
  }

  destroy(): void {
    this.worker.destroy();
    this.requestId = 0;
    this.responseCallbacks.clear();
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = undefined;
    }
  }

  private messageHandler({
    id,
    isCorrect,
    suggestions,
  }: SpellCheckMessage): void {
    if (this.responseCallbacks.has(id)) {
      const callback = this.responseCallbacks.get(id);

      if (callback) {
        this.responseCallbacks.delete(id);
        callback(isCorrect, suggestions);
      }
    }
  }
}
